<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Ready to Work?'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

  <ng-container *ngIf="(isOnIdentificationCheck || isOnFaceUnlock) && loaded">
   <div class="identification-flow">
    <div class="step-tracker">
      <ng-container *ngFor="let step of verificationStepper; let i = index; let last = last; trackBy: trackStepByLabel">
        <div class="step-node" [ngClass]="step.state">
          <div class="step-node-circle">
            <span class="step-node-check" *ngIf="step.state === 'done'">&#10003;</span>
            <span class="step-node-number" *ngIf="step.state !== 'done'">{{ i + 1 }}</span>
          </div>
          <div class="step-node-label">{{ step.label }}</div>
        </div>
        <div class="step-connector" [class.filled]="step.state === 'done'" *ngIf="!last"></div>
      </ng-container>
    </div>

    <div class="identification-body">
    <tidy-row [align]="'center'" class="img-row" *ngIf="!isPhotoPreviewStep">
      <div class="circle-div">
        <tidy-image [src]="currentIdentificationStep.icon" class="step-img"></tidy-image>
      </div>
    </tidy-row>
    <tidy-row [align]="'center'">
      <tidy-text
        class="step-title"
        [header]="currentIdentificationStep.title">
      </tidy-text>
    </tidy-row>
    <tidy-row [align]="'center'">
      <tidy-text
        [body]="currentIdentificationStep.subtitle">
      </tidy-text>
    </tidy-row>

    <!-- Previous attempt failed: surface the Didit status + reason with retry guidance -->
    <ng-container *ngIf="isOnFaceUnlock && lastFailureReason && (currentIdentificationStep === identificationSteps[0] || isPhotoPreviewStep)">
      <div class="attempt-alert">
        <div class="attempt-alert-top">
          <tidy-text class="attempt-alert-title" [body]="attemptFailureTitle"></tidy-text>
          <span class="attempt-alert-chip" *ngIf="attemptStatusLabel">{{ attemptStatusLabel }}</span>
        </div>
        <tidy-text class="attempt-alert-reason" [body]="lastFailureReason"></tidy-text>
        <tidy-text
          class="attempt-alert-tip"
          [smallHelper]="'Find good lighting, remove anything covering your face, and try again.'">
        </tidy-text>
      </div>
    </ng-container>

    <!-- Comparison photo preview (face unlock): the portrait the pro's face is matched against -->
    <ng-container *ngIf="isPhotoPreviewStep && portraitUrl">
      <tidy-row [align]="'center'">
        <div class="portrait-preview">
          <tidy-image
            [src]="portraitUrl"
            loading="eager">
          </tidy-image>
        </div>
      </tidy-row>
      <tidy-row [align]="'center'" class="portrait-caption">
        <tidy-text
          [smallHelper]="'Make sure this is a clear photo of you before continuing.'">
        </tidy-text>
      </tidy-row>
    </ng-container>
    <ng-container *ngIf="currentIdentificationStep === identificationSteps[0] && !isOnFaceUnlock">
      <div style="padding-top: 1rem;">
      </div>
    </ng-container>

    <!-- Video step instructions -->
    <ng-container *ngIf="isVideoStep">
      <tidy-row [align]="'center'" style="margin-bottom: 0.5rem;">
        <countdown [target]="videoDeadline"></countdown>
      </tidy-row>
      <div style="margin: 1rem 0; text-align: left; padding: 0 1rem;">
        <tidy-text [body]="'In about 60 seconds, tell us about:'"></tidy-text>
        <ul style="margin: 0.5rem 0 0.5rem 1.5rem;">
          <li>The history of your business</li>
          <li>What kind of clients you prefer</li>
          <li>Anything else about your business we might want to know</li>
        </ul>
        <tidy-text [body]="'<i>This is not shared with clients.</i>'"></tidy-text>
        <br/><br/>
        <tidy-text [body]="'<b>Important:</b> Make sure we can see you and you match your ID.'"></tidy-text>
      </div>
    </ng-container>

    <tidy-row class="step-button-row" [align]="'center'" *ngIf="currentIdentificationStep.displayButton">
      <tidy-button
        [text]="currentIdentificationStep.buttonText"
        [action]="currentIdentificationStep.action.bind(this)"
        class="primary">
      </tidy-button>
    </tidy-row>

    <!-- Short "how it works" note on the verification start screen -->
    <ng-container *ngIf="currentIdentificationStep === identificationSteps[0]">
      <div class="didit-explainer">
        <tidy-row [align]="'center'" class="didit-explainer-text">
          <tidy-text
            [body]="'Identity verification is powered by Didit. When you continue, a secure window opens to confirm it\'s really you — it usually takes less than a minute.'">
          </tidy-text>
        </tidy-row>
      </div>
    </ng-container>

    <!-- Pro-initiated "photo looks wrong" creates a Concierge item, never a self-reset -->
    <tidy-row [align]="'center'" *ngIf="isPhotoPreviewStep" class="photo-wrong-row">
      <tidy-text
        [body]="'This doesn\'t look like me'"
        class="link"
        (action)="this.reportPortraitIssue()">
      </tidy-text>
    </tidy-row>

    <ng-container *ngIf="identificationError">
      <tidy-alert>
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'<b>Error: </b>'">
          </tidy-text>
          <tidy-text
            [body]="identificationError?.reason">
          </tidy-text>
        </tidy-row>
          <tidy-row [align]="'center'" *ngIf="!isOnFaceUnlock">
            <tidy-text
              [body]="'Verify again.'"
              class="link"
              (action)="this.goToVerificationPage()">
            </tidy-text>
          </tidy-row>
      </tidy-alert>
    </ng-container>
    <ng-container *ngIf="isOnFaceUnlock && !isPhotoPreviewStep && currentIdentificationStep?.title !== 'Verification Complete'">
      <tidy-row [align]="'center'" class="support-link-row">
        <tidy-text
          [body]="'Having trouble? Contact support'"
          class="link"
          (action)="this.reportFaceUnlockIssues()">
        </tidy-text>
      </tidy-row>
    </ng-container>
    </div>

    <div class="didit-badge">
      <tidy-text class="didit-badge-label" [body]="'Powered by'"></tidy-text>
      <tidy-image class="didit-badge-logo" [src]="'assets/img/didit-logo.svg'" loading="eager"></tidy-image>
    </div>
   </div>
  </ng-container>

  <ng-container *ngIf="!isOnIdentificationCheck && !isOnFaceUnlock">
    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'Please confirm you can make your jobs:'">
      </tidy-text>
    </tidy-row>

    <tidy-alert *ngIf="loaded && goodPartnerReminder" class="light-green-background">
      <tidy-row>
        <tidy-text
          [body]="goodPartnerReminder.body">
        </tidy-text>
        <tidy-text
          [body]="' Learn more.'"
          class="link"
          (action)="openGoodPartnerReminderLink()">
        </tidy-text>
      </tidy-row>
    </tidy-alert>

    <ng-container *ngIf="loaded">
      <tidy-card *ngFor="let cleaning of todayCleanings">
        <tidy-row class="extra-bottom-padding">
          <tidy-grid>
            <ion-row>
              <ion-col size="4">
                <tidy-text
                  [body]="cleaning?.job?.start_time | ttime">
                </tidy-text><br>
                <tidy-text
                  [body]="cleaning?.job?.duration_in_minutes + cleaning?.job?.duration_in_minutes > 60 ? ' hours' : ' hour'">
                </tidy-text>
              </ion-col>
              <ion-col size="1">
                <tidy-image
                  *ngIf="cleaning?.homekeeper_job?.repeat_client"
                  [src]="'assets/svg/star-yellow.svg'"
                  class="body-size">
                </tidy-image>
              </ion-col>
              <ion-col size="7" >
                <tidy-text
                  [body]="cleaning?.customer?.first_name">
                </tidy-text><br>
                <tidy-text
                  *ngIf="cleaning?.job_delegation_request?.role !== 'delegatee'"
                  [body]="(cleaning?.service_type_details?.service_category?.name == 'Regular Cleaning' ? 'Cleaning' : cleaning?.service_type_details?.service_category?.name) + ': ' + (cleaning?.payment_price | tcurrency)">
                </tidy-text>
                <tidy-text
                  *ngIf="cleaning?.job_delegation_request?.role === 'delegatee'"
                  [body]="cleaning?.service_type_details?.service_category?.name == 'Regular Cleaning' ? 'Cleaning' : cleaning?.service_type_details?.service_category?.name">
                </tidy-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-divider></tidy-divider>
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/location-outline.svg'">
          </tidy-image>
          <tidy-text
            [body]="'Zip: '"
            class="body-size">
          </tidy-text>
          <tidy-text
            [body]="cleaning?.address?.zip"
            class="body-size">
          </tidy-text>
        </tidy-row>
      </tidy-card>

      <tidy-error-message
        [text]="errorMessage">
      </tidy-error-message>

      <tidy-button item-right
        [text]="'I Will Go to All My Jobs Today'"
        [action]="confirm.bind(this)"
        class="primary">
      </tidy-button>

      <tidy-button item-right
        [text]="'Call Out'"
        [action]="callOut.bind(this)"
        class="secondary">
      </tidy-button>
    </ng-container>
  </ng-container>

    <ng-container *ngIf="!loaded">
      <tidy-card>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="1">
              </ion-col>
              <ion-col size="7">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 45%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-row class="extra-bottom-padding">
          <tidy-divider></tidy-divider>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 32%"></ion-skeleton-text>
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="1">
              </ion-col>
              <ion-col size="7">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 45%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-row class="extra-bottom-padding">
          <tidy-divider></tidy-divider>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 32%"></ion-skeleton-text>
        </tidy-row>
      </tidy-card>
      <tidy-row>
        <ion-skeleton-text animated style="height: 45px"></ion-skeleton-text>
      </tidy-row>
      <tidy-row>
        <ion-skeleton-text animated style="height: 45px"></ion-skeleton-text>
      </tidy-row>
    </ng-container>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
